import options from './chart-motion-agg.component';

export default {
    selector: 'dtChartMotionAgg',
    options
};
